import { LaunchContextConfig } from './types';

export function collectTags(config: LaunchContextConfig): string[] {
  const tags = new Set<string>(['all']);

  const addTags = (itemTags?: string[]) => {
    if (itemTags) itemTags.forEach(t => tags.add(t));
  };

  addTags(config.productGroups?.tags);
  addTags(config.currentGroup?.tags);
  addTags(config.customObject?.tags);
  addTags(config.customAttributes?.tags);

  config.customObject?.choices?.forEach(c => addTags(c.tags));
  config.customAttributes?.presets?.forEach(p => addTags(p.tags));
  config.customAttributes?.attributes?.forEach(a => addTags(a.tags));

  return Array.from(tags).sort();
}

export function shouldShow(itemTags: string[] | undefined, selectedTag: string): boolean {
  if (selectedTag === 'all') return true;
  if (!itemTags || itemTags.length === 0) return false;
  return itemTags.includes(selectedTag);
}
